const eventCategory = "Challan_homepage";
const eventAction = "repeat_user_order_summary";

const repeatUserOrderSummary = {
    eventCategory,
    eventAction,
    event: "repeat_user_order_summary"
};

export { repeatUserOrderSummary };
